import { RouteConfig } from 'vue-router';
const PAGE_TITLE = '重庆市农产品加工业设计大赛';
const baseUrl = 'ncpjgysjds0516';
const route: RouteConfig = {
  path: `/${baseUrl}`,
  name: baseUrl,
  component: () => import('./ViewHolder.vue'),
  redirect: `/${baseUrl}/active`,
  meta: {
    title: PAGE_TITLE,
    showfooter: true,
  },
  children: [
    {
      path: 'active',
      name: `${baseUrl}-active`,
      component: () => import('./pages/Active.vue'),
      meta: {
        title: PAGE_TITLE,
        showfooter: true,
      },
    },
    {
      path: 'news',
      name: `${baseUrl}-news`,
      component: () => import('./pages/News.vue'),
      meta: {
        title: PAGE_TITLE,
        showfooter: true,
      },
    },
    {
      path: 'userActives',
      name: `${baseUrl}-UserActives`,
      component: () => import('./pages/UserActives.vue'),
      meta: {
        title: PAGE_TITLE,
        showfooter: true,
      },
    },
  ],
};
export default route;
